import React from 'react';
import {
    Typography,
    Box,
    Link,
} from '@mui/material';
import { styled } from '@mui/material/styles'
import SubscribeToView from 'components/Common/SubscribeToView';
// import { useSelector } from 'react-redux'

const LinkTextStyle = styled(Box)(() => ({
  color: '#0A78CD',
  fontWeight: 'bold',
  cursor: 'pointer',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  fontSize: '12px',
  fontFamily: 'poppins',
  '&:hover': {
    textDecoration: 'underline',
  },
}))

const CompanyName = {
  fontStyle: "poppins",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#0A78CD"
}

const CommonFields = ({ data }) => {
  return (
    <>
      {data.details.businessName || data.company ? (
        <Typography className="py-1" variant="body1M" sx={CompanyName}>
          {data.details.businessName || data.company}
        </Typography>
      ) : null}
      {data.details.addressStreet || data.address ? (
        <Typography className="py-1" variant="body2">
          Business Address:&nbsp;
          {data.details.addressStreet || data.address}
        </Typography>
      ) : null}
      {data.details.addressCity || data.city ? (
        <Typography className="py-1" variant="body2">
          Business City:&nbsp;
          {data.details.addressCity || data.city}
        </Typography>
      ) : null}
      {data.details.addressState || data.state ? (
        <Typography className="py-1" variant="body2">
          Business State:&nbsp;
          {data.details.addressState || data.state}
        </Typography>
      ) : null}
      {data.details.addressZip || data.zip ? (
        <Typography className="py-1" variant="body2">
          Business Zip:&nbsp;
          {data.details.addressZip || data.zip}
        </Typography>
      ) : null}
      {data.details.addressCountry || data.country ? (
        <Typography className="py-1" variant="body2">
          Business Country:&nbsp;
          {data.details.addressCountry || data.country}
        </Typography>
      ) : null}
      {data.details.website || data.web ? (
        <Typography className="py-1" variant="body2">
          Business Website:&nbsp;
          {data.details.website || data.web}
        </Typography>
      ) : null}
      {data.details.businessEmail || data.email ? (
        <Typography className="py-1" variant="body2">
          Business Email:&nbsp;
          {data.details.businessEmail || data.email}
        </Typography>
      ) : null}
      {data.details.businessPhone || data.phone ? (
        <Typography className="py-1" variant="body2">
          Business Phone Number:&nbsp;
          {data.details.businessPhone || data.phone}
        </Typography>
      ) : null}
      {data.details.businessFax || data.fax ? (
        <Typography className="py-1" variant="body2">
          Business Fax Number:&nbsp;
          {data.details.businessFax || data.fax}
        </Typography>
      ) : null}

      {data.details.businessDescription && (
        <Typography style={{ wordBreak: 'break-word' }} className="py-1" variant="body2">
          Company Description:&nbsp;
          {data.details.businessDescription}
        </Typography>
      )}
      {data.details.category && (
        <Typography className="py-1" variant="body2">
          Category:&nbsp;
          {data.details.category}
        </Typography>
      )}
      {data.details.establishedYear || data.established ? (
        <Typography className="py-1" variant="body2">
          Established: {data.details.establishedYear || data.established}
        </Typography>
      ) : null}
    </>
  )
}

const FreeUser = ({ data }) => {
  // const { details } = data
  return (
    <>
      <CommonFields data={data} />
      <Box display="flex" alignItems="flex-start" justifyContent="space-between">
        <Box display="flex" gap="5px">
          <Box>
            <Typography className="py-1" variant="body2">
              Primary Contact:&nbsp;
              <SubscribeToView />
            </Typography>
          </Box>
        </Box>
      </Box>
      <Typography className="py-1" variant="body2">
        US or Foreign Owned:&nbsp;
        <SubscribeToView />
      </Typography>
      <Typography className="py-1" variant="body2">
        Estimated Number of Employees (This Location):&nbsp;
        <SubscribeToView />
      </Typography>
      <Typography className="py-1" variant="body2">
        Estimated Number of Employees (Corporate):&nbsp;
        <SubscribeToView />
      </Typography>
      <Typography className="py-1" variant="body2">
        Legal Subsidiary - Parent Name:&nbsp;
        <SubscribeToView />
      </Typography>
    </>
  )
}

const CompanyOverview = ({ isFreeAccount, data }) => {
  const { details } = data
  // const { business_info } = useSelector(state => state.apiResponseReducers.dashboardInfo)
  const showClaimed = !isFreeAccount

  return (
    <Box display={'flex'} gap="7px" alignItems="baseline">
      <Box display="flex" flexDirection="column">
        {showClaimed ? (
          <>
            <CommonFields data={data} />
            {details.businessLegalName ? (
              <Typography className="py-1" variant="body2">
                Legal Business Name:&nbsp;
                {details.businessLegalName}
              </Typography>
            ) : null}
            <Box display="flex" alignItems="flex-start" justifyContent="space-between">
              {(details?.primaryContact?.fullName || details?.primaryContact?.lastName || data.cont_name) && (
                <>
                  <Box display="flex" gap="5px">
                    <Box>
                      <Typography className="py-1" variant="body2">
                        Primary Contact:
                      </Typography>
                    </Box>
                    <Box display="flex" flexDirection="column">
                      <Typography className="py-1" variant="body2">
                        {details.primaryContact?.fullName || details?.primaryContact?.lastName
                          ? `${details?.primaryContact?.fullName} ${
                              details?.primaryContact?.title ? '-' + details?.primaryContact?.title : ''
                            }`
                          : `${details?.primaryContact?.fullName || data?.cont_name}  ${
                              details?.primaryContact.title || data?.contact_title_desc
                                ? '-' + (details.primaryContact.title || data.contact_title_desc)
                                : ''
                            }`}
                      </Typography>
                      <Link
                        variant="body2"
                        href={`tel:${details.primaryContact.phone}`}
                        sx={{ textDecoration: 'none' }}
                      >
                        <LinkTextStyle>{details.primaryContact.phone}</LinkTextStyle>
                      </Link>
                      <Link
                        variant="body2"
                        href={`mailto:${details.primaryContact.email}`}
                        sx={{ textDecoration: 'none' }}
                      >
                        <LinkTextStyle>{details.primaryContact.email}</LinkTextStyle>
                      </Link>
                    </Box>
                  </Box>
                </>
              )}
            </Box>
            {details.usOwned ? (
              <Typography className="py-1" variant="body2">
                US or Foreign Owned:&nbsp;
                {details.usOwned === 'Y' ? 'US' : 'Foreign'}
              </Typography>
            ) : null}
            {details.numberOfEmployeesLocal ? (
              <Typography className="py-1" variant="body2">
                Estimated Number of Employees (This Location):&nbsp;
                {details.numberOfEmployeesLocal}
              </Typography>
            ) : null}
            {details.numberOfEmployeesCorporate ? (
              <Typography className="py-1" variant="body2">
                Estimated Number of Employees (Corporate):&nbsp;
                {details.numberOfEmployeesCorporate || data.corp_emp}
              </Typography>
            ) : null}
            {details.veteranOwned === 'Y' ? (
              <Typography className="py-1" variant="body2">
                Veteran Owned:&nbsp;
                {details.veteranOwned === 'Y' ? 'Yes' : ''}
              </Typography>
            ) : null}
            {details.femaleOwned === 'Y' ? (
              <Typography className="py-1" variant="body2">
                Female Owned:&nbsp;
                {details.femaleOwned === 'Y' ? 'Yes' : ''}
              </Typography>
            ) : null}
            {details.minorityOwned === 'Y' ? (
              <Typography className="py-1" variant="body2">
                Minority Owned:&nbsp;
                {details.minorityOwned === 'Y' ? 'Yes' : ''}
              </Typography>
            ) : null}
            {details.governmentEntity === 'Y' ? (
              <Typography className="py-1" variant="body2">
                Government Entity:&nbsp;
                {details.governmentEntity === 'Y' ? 'Yes' : ''}
              </Typography>
            ) : null}
            {details.federalGovernmentEntity === 'Y' ? (
              <Typography className="py-1" variant="body2">
                Federal Government Entity:&nbsp;
                {details.federalGovernmentEntity === 'Y' ? 'Yes' : ''}
              </Typography>
            ) : null}
            {details.nonProfitEntity === 'Y' && (
              <Typography className="py-1" variant="body2">
                Non-Profit Entity:&nbsp;
                {details.nonProfitEntity === 'Y' ? 'Yes' : ''}
              </Typography>
            )}
            {details.educationalInstitutionalIndicator === 'Y' && (
              <Typography className="py-1" variant="body2">
                Educational Institutional Indicator:&nbsp;
                {details.educationalInstitutionalIndicator === 'Y' ? 'Yes' : ''}
              </Typography>
            )}
            {details.legalSubParentName ? (
              <Typography className="py-1" variant="body2">
                Legal Subsidiary - Parent Name:&nbsp;
                {details.legalSubParentName}
              </Typography>
            ) : null}
          </>
        ) : (
          <FreeUser data={data} />
        )}
      </Box>
    </Box>
  )
}

export default CompanyOverview;